export const NoteUnsupported = ({ type }: { type: string }) => (
	<p className="italic text-muted-foreground">Unsupported media type: {type || "Unknown"}</p>
);
